import React from 'react';
import { AutoComplete, Input } from '@/ui';
import { useController } from 'react-hook-form';
import { currenciesList } from '@/utils/static';

export const CurrencySelect = ({ form, label = 'Currency', disabled, required, ...props }) => {
  const {
    field: { ref, ...field },
    fieldState: { error }
  } = useController({
    ...form,
    rules: {
      ...form.rules
    },
    defaultValue: ''
  });

  if (disabled) {
    return <Input {...field} label={label} error={error && error.message} {...props} disabled />;
  }

  return (
    <AutoComplete
      style={{ width: '100%' }}
      {...field}
      label={label}
      items={Object.entries(currenciesList).map((item) => `${item[1].name_plural} (${item[0]})`)}
      error={error && error.message}
      required={required}
      block
      {...props}
    />
  );
};
